import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { Modal, Button } from "react-bootstrap";
import { verifyEmailRequest } from "../../redux/actions/profileActions";

const ChangeMailModal = ({ isOpen, onClose, currentEmail, oemId }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    reset,
  } = useForm({
    defaultValues: {
      email: "",
    },
  });

  const dispatch = useDispatch();
  const { loading, success } = useSelector((state) => state.profile);
  const watchedEmail = watch("email");
  const isSameEmail = watchedEmail === currentEmail;

  const onSubmit = (data) => {
    const emailData = {
      email: data.email,
      oemId: oemId
    };
    dispatch(verifyEmailRequest(emailData));
  };

  React.useEffect(() => {
    if (success) {
      reset();
      onClose();
    }
  }, [success, reset, onClose]);

  const handleClose = () => {
    reset();
    onClose();
  };

  React.useEffect(() => {
    if (isOpen) {
      reset({ email: "" });
    }
  }, [isOpen, reset]);

  return (
    <Modal show={isOpen} onHide={handleClose} centered>
      <Modal.Body>
        <div className="text-center ">
          <h5 className="modal-title mb-3">Change Email Address</h5>
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="form-group mb-3">
            <label>
              Current Email Address
            </label>
            <input
              type="email"
              className="form-control"
              value={currentEmail || ""}
              readOnly
              style={{
                backgroundColor: "#f8f9fa",
                cursor: "not-allowed"
              }}
            />
          </div>
          <div className="form-group mb-3">
            <label>
              New Email Address <span className="text-danger">*</span>
            </label>
            <input
              {...register("email", {
                required: "Email is required",
                pattern: {
                  value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                  message: "Please enter a valid email address",
                },
              })}
              type="email"
              className={`form-control ${errors.email ? "is-invalid" : ""}`}
              placeholder="Enter new email address"
            />
            {errors.email && (
              <div className="invalid-feedback">{errors.email.message}</div>
            )}
          </div>
        </form>
        <div className="d-flex justify-content-end align-items-center gap-2">
          <button className="cancel-btns" onClick={handleClose}>
            Cancel
          </button>
          <button
            onClick={handleSubmit(onSubmit)}
            className="send-btn"
            disabled={loading || isSameEmail}
          >
            {loading ? "Sending..." : "Update Email"}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ChangeMailModal;
